import { cx, focusRing } from '../../lib/utils'

interface SwitchProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  'aria-label': string
  className?: string
}

/**
 * Un interruttore acceso/spento.
 *
 * Un `<button role="switch">` e non una casella di spunta: qui non si compila
 * un modulo da inviare, si cambia una cosa che vale subito, e "switch" è
 * quello che un lettore di schermo deve annunciare. Nessuna dipendenza nuova
 * per due dozzine di righe.
 */
export default function Switch({
  checked,
  onCheckedChange,
  disabled,
  className,
  ...props
}: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={props['aria-label']}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cx(
        'relative inline-flex h-6 w-11 shrink-0 rounded-full transition',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-primary-600' : 'bg-gray-200 dark:bg-gray-700',
        focusRing,
        className
      )}
    >
      <span
        aria-hidden="true"
        className={cx(
          'pointer-events-none absolute top-0.5 size-5 rounded-full bg-white shadow transition-all',
          checked ? 'left-[1.375rem]' : 'left-0.5'
        )}
      />
    </button>
  )
}
